import React from "react";
import { Navbar } from "../components/site/Navbar";
import { Pricing } from "../components/site/Pricing";
import { Footer } from "../components/site/Footer";
import { Testimonials } from "../components/site/Testimonials";

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="pricing-page">
      <Navbar />
      <main className="pt-28">
        <Pricing compact />
        <div className="pt-20">
          <Testimonials />
        </div>
      </main>
      <Footer />
    </div>
  );
}
